// import file from '../../assets/file.pdf'

// ########### CTA = Call to Action ###########

const CTA = () => {
  return (
    <div className='cta'>
        <a href = "#contact" className='btn'>Let's Talk</a>
        {/* <a href = {file} download className='btn btn-primary'>Download Resume</a> */}
    </div>
  )
}

export default CTA